// iubenda integration helpers (Consent Solution + Privacy/Cookie Policy)
// Site: MEDISISTEM — siteId 4678368, cookiePolicyId 10902254
export const IUBENDA_SITE_ID = 4678368;
export const IUBENDA_POLICY_ID = 10902254;
export const IUBENDA_PRIVACY_URL = `https://www.iubenda.com/privacy-policy/${IUBENDA_POLICY_ID}`;
export const IUBENDA_COOKIE_URL = `${IUBENDA_PRIVACY_URL}/cookie-policy`;

// Re-open the iubenda cookie preferences panel
export const openCookiePreferences = () => {
  try {
    const api = window._iub && window._iub.cs && window._iub.cs.api;
    if (api && typeof api.openPreferences === "function") {
      api.openPreferences();
      return;
    }
  } catch {
    /* no-op */
  }
  const link = document.querySelector(".iubenda-cs-preferences-link");
  if (link) link.click();
};

// Read the iubenda consent cookie (_iub_cs-<siteId>)
const readIubCookie = () => {
  const m = document.cookie.match(/(?:^|;\s*)_iub_cs-s?\d+=([^;]+)/);
  if (!m) return null;
  try {
    return JSON.parse(decodeURIComponent(m[1]));
  } catch {
    return null;
  }
};

// True only after the user has expressed consent to non-necessary purposes
// (Google Maps / external content). Blocked by default and on full rejection.
export const hasExternalContentConsent = () => {
  const c = readIubCookie();
  if (!c) return false;
  if (c.purposes && typeof c.purposes === "object") {
    return Object.entries(c.purposes).some(([k, v]) => k !== "1" && v === true);
  }
  return c.consent === true;
};

// True once the user has expressed any cookie choice (accept or reject)
export const hasExpressedChoice = () => !!readIubCookie();

// Consent change notification.
// PRIMARY: iubenda native callbacks (registered in index.html before the widget)
// dispatch the 'ms-consent-change' event. FALLBACK: a lightweight cookie poller
// is started only if the native callbacks did not initialise (equivalent behaviour).
let watching = false;
export const startConsentWatcher = () => {
  if (watching) return;
  watching = true;
  setTimeout(() => {
    if (window.__iubNativeCallbacks) return; // native events active → no polling needed
    const snapshot = () => document.cookie.match(/_iub_cs-s?\d+=[^;]*/)?.[0] || "";
    let last = snapshot();
    setInterval(() => {
      const cur = snapshot();
      if (cur !== last) {
        last = cur;
        window.dispatchEvent(
          new CustomEvent("ms-consent-change", { detail: { maps: hasExternalContentConsent() } })
        );
      }
    }, 800);
  }, 3000);
};

// Load the shared iubenda.js loader once (used to embed Privacy & Cookie Policy)
export const loadIubendaLegal = () => {
  if (document.getElementById("iubenda-legal-loader")) return;
  const s = document.createElement("script");
  s.id = "iubenda-legal-loader";
  s.type = "text/javascript";
  s.src = "https://cdn.iubenda.com/iubenda.js";
  s.async = true;
  (document.body || document.head).appendChild(s);
};
